import styled from 'styled-components';
import { ModalVariant } from './JRCModalLayout';

export type ModalBorderRadius = 'medium' | 'small';

export const JRCModalBox = styled.div<{ isFullHeight?: boolean; overflow?: 'visible' | 'hidden'; zIndex?: number }>`
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.7);
    z-index: ${({ zIndex, theme }) => zIndex ?? theme.zIndex.modal};
    overflow: ${(props) => (props.overflow ?? props.isFullHeight ? 'auto' : 'hidden')};
    padding: ${(props) => (props.isFullHeight ? '50px' : '0')};
`;

export const JRCModalContainerFull = styled.div<{ isFullScreen?: boolean; maxHeight?: string }>`
    background-color: ${(props) => props.theme.color.white};
    border-radius: 0;
    bottom: 0;
    display: flex;
    flex-direction: column;
    left: 0;
    margin: 0;
    overflow: hidden;
    position: fixed;
    right: 0;
    top: ${(props) => (props.isFullScreen ? '0' : '90')}px;
    z-index: unset;
    max-height: ${(props) => props.maxHeight || 'inherit'};
`;

export const JRCModalContainer = styled.div<{
    variant?: ModalVariant;
    overflow?: 'hidden' | 'visible';
    radius?: ModalBorderRadius;
    maxHeight?: string;
}>`
    position: relative;
    border-radius: ${(props) => (props.radius === 'small' ? '8px' : '16px')};
    min-width: 260px;
    margin: ${(props) => (props.variant === 'full-height' ? 'auto' : '20px')};
    max-width: 720px;
    max-height: ${(props) =>
        props.variant === 'full-height'
            ? 'auto'
            : props.maxHeight
            ? `min(calc(100vh - 86px), ${props.maxHeight})`
            : 'calc(100vh - 86px)'};
    height: ${(props) => (props.variant === 'fixed-height' ? '100%' : 'inherit')};
    background-color: ${(props) => props.theme.color.white};
    display: flex;
    flex-direction: column;
    z-index: unset;
    overflow: ${({ overflow }) => (overflow === 'visible' ? 'visible' : 'hidden')};

    @media (min-width: 640px) {
        margin: ${(props) => (props.variant === 'full-height' ? 'auto' : '50px')};
        width: 85vw;
    }
`;

export const JRCModalTitle = styled.div`
    flex: 1;
    display: flex;
    justify-content: flex-start;
    align-items: center;
`;

export const JRCModalOptions = styled.div``;

export const JRCModalBody = styled.div<{
    modalOverflow?: 'hidden' | 'scroll' | 'visible' | 'auto';
}>`
    padding: ${({ modalOverflow, theme }) => (modalOverflow === 'scroll' ? theme.space.md : 0)}px
        ${({ theme }) => theme.space.md}px;
    display: flex;
    flex: 1;
    flex-direction: column;
    min-height: ${(props) => (props.modalOverflow === 'scroll' ? 'inherit' : '0px')};
    ${(props) =>
        props.modalOverflow ? `overflow: ${props.modalOverflow === 'scroll' ? 'auto' : props.modalOverflow};` : ''}
`;

export const JRCModalContentFull = styled.div`
    padding: 0;
    display: flex;
    flex: 1;
    flex-direction: column;
    min-height: 0;
`;

export const JRCModalHeader = styled.div<{
    modalOverflow?: 'hidden' | 'scroll' | 'visible' | 'auto';
}>`
    border-bottom: ${(props) => (props.modalOverflow === 'scroll' ? `1px solid ${props.theme.color.grey2}` : 'none')};
    z-index: 10;
    flex-shrink: 0;
    min-height: 16px;
    padding: 10px 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

export const JRCModalFooter = styled.div<{
    modalOverflow?: 'hidden' | 'scroll' | 'visible';
}>`
    border-top: ${(props) => (props.modalOverflow === 'scroll' ? `1px solid ${props.theme.color.grey2}` : 'none')};
    flex-shrink: 0;
    display: flex;
    justify-content: flex-end;
    padding: ${(props) => (props.modalOverflow === 'scroll' ? '10px' : '24px')};
    z-index: 0;
`;

export const JRCModalClose = styled.div``;
